export const NAME = 'SingleFlightTracker';



// WEBPACK FOOTER //
// ./modules/SingleFlight/redux/constants.js